(function ($) {
    'use strict';
    $(document).ready(function () {
        //Get responsive menu
        var respMenu = $('.responsive-menu');
        //Hide menu (default open)
        respMenu.removeClass('responsive-menu--show');
        //Find all expandable menu items 
        var expandable = respMenu.find('.responsive-menu__item--expandable');
      
        expandable.on('click', function (event) {
            var source = $(event.target);
            var parent = source.parent();
            parent.toggleClass('responsive-menu__item--expanded');
            if (source.attr('aria-expanded') === 'true') {
                source.attr('aria-expanded', 'false');
            } else {
                source.attr('aria-expanded', 'true');
            }
        });
    });
}(jQuery));